// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.uib-datepicker-popup {
  z-index: 10;
}
.uib-datepicker-popup .react-datepicker {
  width: 100%;
}
.uib-datepicker-popup .react-datepicker__month-container {
  width: 100%;
}
.uib-datepicker-popup .react-datepicker__navigation--previous {
  top: 10px;
}
.uib-datepicker-popup .react-datepicker__navigation--next {
  top: 10px;
}
.uib-datepicker-popup .custom-footer {
  margin-bottom: 2px;
}
.uib-datepicker-popup .custom-footer .btn-today {
  background-color: #faa718;
  border-color: #faa718;
  color: #ffffff;
  border: none;
  margin-top: 1px;
  margin-left: 2px;
  position: absolute;
  right: 0;
  margin-right: 1rem;
}
.uib-datepicker-popup .custom-footer .btn-today:hover {
  background-color: #81a2ca;
  border-color: #81a2ca;
}
.uib-datepicker-popup .custom-footer .btn-clear {
  background-color: #81a2ca;
  border-color: #81a2ca;
  color: #ffffff;
  border: none;
  margin-top: 1px;
  margin-left: 2px;
}
.uib-datepicker-popup .custom-footer .btn-clear:hover {
  background-color: #4a709d;
  border-color: #4a709d;
}
.uib-datepicker-popup .custom-footer .btn-close {
  background-color: #5cb85c;
  color: #ffffff;
  border: none;
  position: absolute;
  right: 0px;
  margin-top: 1px;
  margin-right: 2px;
}
.uib-datepicker-popup .custom-footer .btn-close:hover {
  background-color: #636363;
}
.uib-datepicker-popup .date-picker-input {
  z-index: 0;
}
.uib-datepicker-popup .react-datepicker__month-text {
  border: #ccc 1px solid;
  border-radius: 4px;
  margin: 0;
  width: 33.33%;
}
.uib-datepicker-popup .react-datepicker__month-text.react-datepicker__month--selected {
  color: #fff;
  background-color: #216ba5;
  border-color: #216ba5;
}
.waiver-reporting-datepicker .react-datepicker__month-text {
  height: 2rem;
  align-content: center;
  font-size: 1rem;
}
.waiver-reporting-datepicker .react-datepicker__month-text--today {
  font-weight: normal;
}
.waiver-reporting-datepicker .year-select__single-value {
  font-size: 1rem;
}
.waiver-reporting-datepicker .year-select__menu-list {
  height: 11rem;
}
.uib-datepicker-popup.full-width {
  width: 100%;
}
.react-datepicker__navigation--previous {
  left: -5px;
}
.react-datepicker__navigation--next {
  right: -5px;
}
ul[row] {
  background: transparent;
  border: 0;
  border-radius: 0;
  -moz-border-radius: 0;
  -webkit-border-radius: 0;
  -webkit-box-shadow: 0 0 0;
  box-shadow: 0 0 0;
}
ul[row] li[ng-if='showButtonBar'] {
  background: #7d7d7d;
  text-align: center;
  border-bottom: 1px solid #7d7d7d;
  border-bottom: 1px solid rgba(0, 0, 0, 0.2);
  border-right: 1px solid #7d7d7d;
  border-right: 1px solid rgba(0, 0, 0, 0.2);
  border-left: 1px solid #7d7d7d;
  border-left: 1px solid rgba(0, 0, 0, 0.2);
}
ul[row] li[ng-if='showButtonBar'] .pull-right {
  float: none !important;
}
ul[row] li[ng-if='showButtonBar'] .btn,
ul[row] li[ng-if='showButtonBar'] .btn:hover,
ul[row] li[ng-if='showButtonBar'] .btn:focus {
  outline: none;
}
ul[row] li[ng-if='showButtonBar'] .btn:hover,
ul[row] li[ng-if='showButtonBar'] .btn:focus {
  color: #ffdaa0;
}
ul[row] li[ng-if='showButtonBar'] .btn-group .btn:first-child:not(:last-child):not(.dropdown-toggle),
ul[row] li[ng-if='showButtonBar'] .btn-group .btn:last-child:not(:first-child) {
  border-radius: 3px;
  -moz-border-radius: 3px;
  -webkit-border-radius: 3px;
}
ul[row] li[ng-if='showButtonBar'] .btn-group .btn {
  border: 0;
  background: #faa718;
  margin: -15px 5px 13px 5px;
  padding-left: 25px;
  padding-right: 25px;
  font-size: 14px;
  color: #ffffff;
}
ul[row] li[ng-if='showButtonBar'] .btn-group .btn:hover,
ul[row] li[ng-if='showButtonBar'] .btn-group .btn:focus {
  background: #ffdaa0;
  color: #ffffff;
}
ul[row] li[ng-if='showButtonBar'] button[ng-click='close()'] {
  background: #071c35;
  position: absolute;
  top: 40px;
  font-size: 18px;
  font-weight: bold;
  margin-left: 15px;
  border: 0;
  padding: 0;
}
.date-selector-input .form-control:last-child {
  border-top-left-radius: 4px;
  border-bottom-left-radius: 4px;
}
.italic-placeholder::placeholder {
  font-style: italic;
}
.custom-placeholder::placeholder {
  font-style: italic;
  color: white;
}
.preset-option {
  display: flex;
}
.preset-option label {
  font-weight: normal;
}
`, "",{"version":3,"sources":["webpack://./src/styles/modules/waiver-reporting.less"],"names":[],"mappings":"AAaA;EA4EE,WAAA;AAvFF;AAWA;EAEI,WAAA;AAVJ;AAQA;EAKI,WAAA;AAVJ;AAKA;EASI,SAAA;AAXJ;AAEA;EAaI,SAAA;AAZJ;AADA;EAiBI,kBAAA;AAbJ;AAJA;EAoBM,yBAAA;EACA,qBAAA;EACA,cAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,QAAA;EACA,kBAAA;AAbN;AAcM;EACE,yBAAA;EACA,qBAAA;AAZR;AAnBA;EAoCM,yBAAA;EACA,qBAAA;EACA,cAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;AAdN;AAeM;EACE,yBAAA;EACA,qBAAA;AAbR;AA/BA;EAiDM,yBAAA;EACA,cAAA;EACA,YAAA;EACA,kBAAA;EACA,UAAA;EACA,eAAA;EACA,iBAAA;AAfN;AAgBM;EACE,yBAAA;AAdR;AA3CA;EA+DI,UAAA;AAjBJ;AA9CA;EAkEI,sBAAA;EACA,kBAAA;EACA,SAAA;EACA,aAAA;AAjBJ;AAkBI;EACE,WAAA;EACA,yBAAA;EACA,qBAAA;AAhBN;AAsBA;EAEI,YAAA;EACA,qBAAA;EACA,eAAA;AArBJ;AAiBA;EAOI,mBAAA;AArBJ;AAcA;EAUI,eAAA;AArBJ;AAWA;EAaI,aAAA;AArBJ;AAyBA;EACE,WAAA;AAvBF;AA0BA;EACE,UAAA;AAxBF;AA0BA;EACE,WAAA;AAxBF;AA2BA;EACE,uBAAA;EACA,SAAA;EACA,gBAAA;EACA,qBAAA;EACA,wBAAA;EACA,yBAAA;EACA,iBAAA;AAzBF;AAkBA;EAUI,mBAAA;EACA,kBAAA;EAoDA,gCAAA;EACA,2CAAA;EACA,+BAAA;EACA,0CAAA;EACA,8BAAA;EACA,yCAAA;AA5EJ;AAQA;EAcM,sBAAA;AAnBN;AAKA;;;EAoBM,aAAA;AApBN;AAAA;;EAyBM,cAAA;AArBN;AAJA;;EA+BQ,kBAAA;EACA,uBAAA;EACA,0BAAA;AAvBR;AAVA;EAqCQ,SAAA;EACA,mBAAA;EACA,0BAAA;EACA,kBAAA;EACA,mBAAA;EACA,eAAA;EACA,cAAA;AAxBR;AAnBA;;EA+CQ,mBAAA;EACA,cAAA;AAxBR;AAxBA;EAqDM,mBAAA;EACA,kBAAA;EACA,SAAA;EACA,eAAA;EACA,iBAAA;EACA,iBAAA;EACA,SAAA;EACA,UAAA;AA1BN;AAqCA;EACE,2BAAA;EACA,8BAAA;AAnCF;AAsCA;EACE,kBAAA;AApCF;AAuCA;EACE,kBAAA;EACA,YAAA;AArCF;AAwCA;EACE,aAAA;AAtCF;AAqCA;EAGI,mBAAA;AArCJ","sourcesContent":["@import 'colors';\n\n@datepicker-bg-color: @gray3;\n@datepicker-btn-bg-color: @orange;\n@datepicker-btn-hover-bg-color: @orangeHiLite;\n@datepicker-btn-text-color: @white;\n@datepicker-close-btn-hover-text-color: @orangeHiLite;\n@datepicker-btn-hover-text-color: @white;\n@datepicker-header-bg-color: @blue1;\n@datepicker-body-bg-color: @white;\n@datepicker-header-text-color: @white;\n@datepicker-value-text-color: @blue1;\n\n.uib-datepicker-popup {\n  .react-datepicker {\n    width: 100%;\n  }\n  .react-datepicker__month-container {\n    width: 100%;\n      }\n\n  .react-datepicker__navigation--previous {\n    top: 10px;\n  }\n\n  .react-datepicker__navigation--next {\n    top: 10px; \n  }\n\n  .custom-footer {\n    margin-bottom: 2px;\n\n    .btn-today {\n      background-color: @orange1;\n      border-color: @orange1;\n      color: @white;\n      border: none;\n      margin-top: 1px;\n      margin-left: 2px;\n      position: absolute;\n      right: 0;\n      margin-right: 1rem;\n      &:hover {\n        background-color: @blue6;\n        border-color: @blue6;\n      }\n    }\n  \n    .btn-clear {\n      background-color: @blue6;\n      border-color: @blue6;\n      color: @white;\n      border: none;\n      margin-top: 1px;\n      margin-left: 2px;\n      &:hover {\n        background-color: @blue5;\n        border-color: @blue5;\n      }\n    }\n  \n    .btn-close {\n      background-color: #5cb85c;\n      color: @white;\n      border: none;\n      position: absolute;\n      right: 0px;\n      margin-top: 1px;\n      margin-right: 2px;\n      &:hover {\n        background-color: darken(@gray3, 10%);\n      }\n    }\n  }\n\n  .date-picker-input {\n    z-index: 0;\n  }\n  .react-datepicker__month-text {\n    border: #ccc 1px solid;\n    border-radius: 4px;\n    margin: 0;\n    width: 33.33%;\n    &.react-datepicker__month--selected {\n      color: #fff;\n      background-color: #216ba5;\n      border-color: #216ba5;\n    }\n  }\n  z-index: 10;\n}\n\n.waiver-reporting-datepicker {\n  .react-datepicker__month-text {\n    height: 2rem;\n    align-content: center;\n    font-size: 1rem;\n  }\n  .react-datepicker__month-text--today {\n    font-weight: normal;\n  }\n  .year-select__single-value {\n    font-size: 1rem;\n  }\n  .year-select__menu-list {\n    height: 11rem;\n  }\n}\n\n.uib-datepicker-popup.full-width {\n  width: 100%;\n}\n\n.react-datepicker__navigation--previous {\n  left: -5px;\n}\n.react-datepicker__navigation--next {\n  right: -5px;\n}\n\nul[row] {\n  background: transparent;\n  border: 0;\n  border-radius: 0;\n  -moz-border-radius: 0;\n  -webkit-border-radius: 0;\n  -webkit-box-shadow: 0 0 0;\n  box-shadow: 0 0 0;\n\n  li[ng-if='showButtonBar'] {\n    background: @datepicker-bg-color;\n    text-align: center;\n\n    .pull-right {\n      float: none !important;\n    }\n\n    .btn,\n    .btn:hover,\n    .btn:focus {\n      outline: none;\n    }\n\n    .btn:hover,\n    .btn:focus {\n      color: @datepicker-close-btn-hover-text-color;\n    }\n\n    .btn-group {\n      .btn:first-child:not(:last-child):not(.dropdown-toggle),\n      .btn:last-child:not(:first-child) {\n        border-radius: 3px;\n        -moz-border-radius: 3px;\n        -webkit-border-radius: 3px;\n      }\n\n      .btn {\n        border: 0;\n        background: @datepicker-btn-bg-color;\n        margin: -15px 5px 13px 5px;\n        padding-left: 25px;\n        padding-right: 25px;\n        font-size: 14px;\n        color: @datepicker-btn-text-color;\n      }\n      .btn:hover,\n      .btn:focus {\n        background: @datepicker-btn-hover-bg-color;\n        color: @datepicker-btn-hover-text-color;\n      }\n    }\n\n    button[ng-click='close()'] {\n      background: @datepicker-header-bg-color;\n      position: absolute;\n      top: 40px;\n      font-size: 18px;\n      font-weight: bold;\n      margin-left: 15px;\n      border: 0;\n      padding: 0;\n    }\n\n    border-bottom: 1px solid @datepicker-bg-color;\n    border-bottom: 1px solid rgba(0, 0, 0, 0.2);\n    border-right: 1px solid @datepicker-bg-color;\n    border-right: 1px solid rgba(0, 0, 0, 0.2);\n    border-left: 1px solid @datepicker-bg-color;\n    border-left: 1px solid rgba(0, 0, 0, 0.2);\n  }\n}\n.date-selector-input .form-control:last-child {\n  border-top-left-radius: 4px;\n  border-bottom-left-radius: 4px;\n}\n\n.italic-placeholder::placeholder {\n  font-style: italic;\n}\n\n.custom-placeholder::placeholder {\n  font-style: italic;\n  color: white;\n}\n\n.preset-option {\n  display: flex;\n  label {\n    font-weight: normal;\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
